import { toUser } from 'data/dto/user.dto';
import { User } from 'data/models/user.interface';
import create from 'zustand';

interface UserState {
  user: User;
  setUser: (_user: User) => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: toUser({}),
  setUser: (user) => set({ user }),
}));
